import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { BatchStatus, useBabelfish } from '@/comp/use-babelfish';
import { SourceType } from '@ilteducation/babelfish-types';

type Props = {
  title: string;
  resource: any;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  props: {
    title: null,
    resource: null
  },
  setup(__props: any) {



const resourcesWithTranslations: SourceType[] = ['keyword', 'image'];

const { lokaliseProjectId, orderedLanguages, resourcesConfigs, triggerBatchJob, triggerInProgress, batchJobStatus } =
  useBabelfish();

// combining language configs from all resources
const languageConfigs = computed(
  () =>
    resourcesWithTranslations
      .map((r, k) => resourcesConfigs.value[k].languageConfigs)
      .reduce((acc, currentConfigs) => {
        return { ...acc, ...currentConfigs };
      }, {}) || {},
);
const currentLanguages = computed(() =>
  resourcesWithTranslations
    .map((r) => orderedLanguages(r))
    .flat()
    // no duplicate languages
    .filter((lang, index, self) => self.indexOf(lang) === index),
);

const fields = computed(() => {
  const fs: { source: string; label?: string; width?: string }[] = [
    {
      source: 'name',
      label: 'Source',
    },
  ];

  currentLanguages.value.forEach((lang) => {
    fs.push({
      label: lang,
      source: `translations.${lang}`,
      width: '73px',
    });
  });
  return fs;
});

const filters = [
  {
    source: 'inProgress',
    type: 'boolean',
    attributes: {
      multiple: true,
    },
  },
  {
    source: 'sourceType',
    type: 'select',
    attributes: {
      multiple: true,
      choices: resourcesWithTranslations.map((r) => ({
        text: r.charAt(0).toUpperCase() + r.slice(1),
        value: r,
      })),
    },
    alwaysOn: true,
  },
];

const batchStatus = ref<BatchStatus>();
let batchStatusJob: NodeJS.Timeout;

const updateJobStatus = () => {
  batchJobStatus().then((status) => {
    batchStatus.value = status;
  });
};

const trigger = async () => {
  await triggerBatchJob();
  updateJobStatus();
};

onMounted(() => {
  batchStatusJob = setInterval(updateJobStatus, 5000);
});

onUnmounted(() => {
  if (batchStatusJob) {
    clearTimeout(batchStatusJob);
  }
});

return { __sfc: true,resourcesWithTranslations, lokaliseProjectId, orderedLanguages, resourcesConfigs, triggerBatchJob, triggerInProgress, batchJobStatus, languageConfigs, currentLanguages, fields, filters, batchStatus, batchStatusJob, updateJobStatus, trigger }
}

})